import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../helpers/AuthContext';
import { toast } from 'react-toastify';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      const from = location.state?.from?.pathname || '/';
      navigate(from);
    } catch (error) {
      toast.error(`Erreur lors de la connexion: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-950 px-4">
      <div className="w-full max-w-md bg-gray-900 border border-gray-700 rounded-2xl p-8 shadow-xl">

        {/* Logo */}
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-xl bg-green-600 flex items-center justify-center flex-shrink-0">
            <i className="fa fa-shield text-white text-lg"></i>
          </div>
          <div>
            <p className="text-white font-semibold text-base leading-tight">DCCA</p>
            <p className="text-gray-400 text-xs">Système de gestion du personnel</p>
          </div>
        </div>

        {/* Titre */}
        <h1 className="text-xl font-semibold text-white mb-1">Authentification</h1>
        <p className="text-gray-400 text-sm mb-7">Connectez-vous pour accéder à votre espace</p>

        <form onSubmit={handleSubmit} className="space-y-5">

          {/* Identifiant */}
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-400 mb-1.5">
              Identifiant
            </label>
            <div className="relative">
              <i className="fa fa-user absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none"></i>
              <input
                id="username"
                name="username"
                type="text"
                autoComplete="off"
                placeholder="Votre nom d'utilisateur"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full bg-gray-800 border border-gray-600 text-white text-sm rounded-xl pl-9 pr-4 py-2.5 placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20 transition-all"
              />
            </div>
          </div>

          {/* Mot de passe */}
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-400 mb-1.5">
              Mot de passe
            </label>
            <div className="relative">
              <i className="fa fa-lock absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 text-sm pointer-events-none"></i>
              <input
                id="password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-gray-800 border border-gray-600 text-white text-sm rounded-xl pl-9 pr-10 py-2.5 placeholder-gray-500 focus:outline-none focus:border-green-500 focus:ring-2 focus:ring-green-500/20 transition-all"
              />
              {/* Toggle affichage mot de passe */}
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-300 transition-colors"
              >
                <i className={`fa ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-sm`}></i>
              </button>
            </div>
          </div>

          {/* Bouton submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-medium py-2.5 rounded-xl transition-colors duration-200 mt-2"
          >
            {loading ? (
              <>
                <i className="fa fa-spinner fa-spin text-sm"></i>
                Connexion en cours...
              </>
            ) : (
              <>
                <i className="fa fa-sign-in text-sm"></i>
                Se connecter
              </>
            )}
          </button>
        </form>

        <hr className="border-gray-700 my-6" />
        <p className="text-center text-xs text-gray-500">Accès réservé au personnel autorisé</p>
      </div>
    </div>
  );
}

export default Login;